import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { Intro } from "@/components/landing/Intro";
import { Home } from "@/pages/Home";
import { About } from "@/pages/About";
import { Clientele } from "@/pages/Clientele";
import { Contact } from "@/pages/Contact";
import { Catalog } from "@/pages/Catalog";
import { Admin } from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [introDone, setIntroDone] = useState(
    () => window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  const handleIntroDone = useCallback(() => setIntroDone(true), []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-paper font-body text-ink antialiased">
      <BrowserRouter>
        <ScrollToTop />
        {!introDone && <Intro onDone={handleIntroDone} />}
        <Navbar />
        <Routes>
          <Route path="/" element={<Home ready={introDone} />} />
          <Route path="/about" element={<About />} />
          <Route path="/clientele" element={<Clientele />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
